export default __webpack_public_path__ + "static/media/Gareth.04e32047.png";